import AjaxLoadedWebsiteModal from "webPage/modal/AjaxLoadedWebsiteModal";
import { EVENT_GLOBAL_ATTACH } from "base/FormValidator";
import GlobalEvents from "base/GlobalEvents";

GlobalEvents.on(EVENT_GLOBAL_ATTACH, (validator) => {
    validator.on("input:showMessage", ({input}) => {
        input.$input.closest(".field").addClass("field--error");
    }).on("input:hideMessage", ({input}) => {
        input.$input.closest(".field").removeClass("field--error");
    });
});

$.extend(true, AjaxLoadedWebsiteModal.global_settings, {
    buildLoadingModal: () => (
        eotwJSXFactory('div', {className: "modal modal--loading"}, [
            eotwJSXFactory('div', {className: "modal__overlay js-close-modal"}),
            eotwJSXFactory('div', {className: "modal__container"}, [
                eotwJSXFactory('button', {className: "modal__close js-close-modal", title: "Close", 'aria-label': "Close Modal"}, [eotwJSXFactory('span', {className: "modal__close-icon"})]),
                eotwJSXFactory('div', {className: "modal__content"})
            ])
        ])
    ),
});

const MODAL_INDEX = 1;
